import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiRadio from '@material-ui/core/Radio';
// @ts-ignore
import RadioButtonIcon from '@material-ui/core/Radio/RadioButtonIcon';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { withTooltip } from '../../Tooltip';
import { RcFormControlLabel } from '../FormControlLabel';
import { CustomIconPropsGetter } from '../utils';
import { RadioStyle } from './styles';
import { RadioButtonIconClasses, RcRadioClasses } from './utils';
var getIconProps = CustomIconPropsGetter({
    checkedIcon: React.createElement(RadioButtonIcon, { checked: true, classes: RadioButtonIconClasses }),
    icon: React.createElement(RadioButtonIcon, { classes: RadioButtonIconClasses }),
});
var _RcRadio = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcRadio' });
    var label = props.label, formControlLabelProps = props.formControlLabelProps, color = props.color, error = props.error, followColorWhenUnChecked = props.followColorWhenUnChecked, classesProp = props.classes, size = props.size, icon = props.icon, checkedIcon = props.checkedIcon, rest = __rest(props, ["label", "formControlLabelProps", "color", "error", "followColorWhenUnChecked", "classes", "size", "icon", "checkedIcon"]);
    var classes = useMemo(function () { return combineClasses(RcRadioClasses, classesProp); }, [classesProp]);
    var iconProps = useMemo(function () { return getIconProps({ size: size, icon: icon, checkedIcon: checkedIcon }); }, [checkedIcon, icon, size]);
    var Radio = (React.createElement(MuiRadio, __assign({}, iconProps, rest, { ref: ref, color: "default", classes: classes })));
    if (label) {
        return (React.createElement(RcFormControlLabel, __assign({}, formControlLabelProps, { label: label, control: Radio })));
    }
    return Radio;
});
var RcRadio = styled(withTooltip(_RcRadio))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), RadioStyle);
RcRadio.defaultProps = {
    color: 'interactive.f01',
    size: 'medium',
};
RcRadio.displayName = 'RcRadio';
export { RcRadio };
var templateObject_1;
